<template>
  <div class="img-wrap">
    <swiper :modules="[SwiperPagination,SwiperNavigation]"
            navigation
            pagination
            :slides-per-view="1"
            :loop="true">
      <swiper-slide v-for="(spaceImg,photoIndex) in spacePhotoModelValue"
                    :key="picUrl+photoIndex"
                    @click="handleSpacePhoto(route.params.spaceid)">
        <div class="flex justify-center px-[20px]">
          <!--          <img :src="picUrl+spaceImg.url"
                         alt="空間照片">-->
          <NuxtImg class="rounded-[10px] sm:w-full md:w-[85%] max-w-[1000px]"
                   format="webp"
                   quality="90"
                   sizes="sm:100vw md:1000px"
                   loading="lazy"
                   :src="picUrl+spaceImg.url"
                   :alt="spaceImg.description?spaceImg.description:spaceNameModelValue"/>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script setup
        lang="ts">
import 'swiper/css';
import 'swiper/css/pagination';
import {ref} from "vue";

const picUrl = ref(import.meta.env.VITE_APP_BASE_IMG_URL)
const router = useRouter()
const route = useRoute();
const spacePhotoModelValue = defineModel('spacePhotoObj', {type: Object, default: {}})
const spaceNameModelValue = defineModel('spaceName', {type: String, default: ''})


const handleSpacePhoto = (spaceid) => {
  router.push({path: `/admin-photo/${spaceid}`})
}

</script>


<style scoped
       lang="scss">
.img-wrap {
  @apply relative cursor-pointer;
  :deep(.swiper-button-prev ), :deep(.swiper-button-next) {
    @apply w-[35px] h-[35px] bg-white rounded-full text-black text-[10px];
    box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);


    &::after {
      @apply text-[22px];
    }
  }

  :deep(.swiper-pagination-bullet-active) {
    @apply bg-osn-yellow-00;
  }
}
</style>
